export default "__VITE_ASSET__2f63ec75__"